export const HOME_PATH = "/";
export const TERMS_CONDITIONS_PATH = "/terms-and-conditions";
export const TERMS_TO_UPDATE_PATH = "/terms-to-update";

export const LOGIN_PATH = "/login";
export const SIGNUP_PATH = "/sign-up";

export const INVITE_PATH = "/invitations/:token";
export const INVITE_SETUP_PATH = "/invitations/setup";

// These full paths are required for the Stripe - start
export const INVITE_SETUP_SUCCESS_PATH = "https://app.bemakers.com/invitations/setup?success=true";
export const INVITE_SETUP_CANCEL_PATH = "https://app.bemakers.com/invitations/setup?cancel=true";
export const STG_INVITE_SETUP_SUCCESS_PATH = "https://app.staging-bemakers.com/invitations/setup?success=true";
export const STG_INVITE_SETUP_CANCEL_PATH = "https://app.staging-bemakers.com/invitations/setup?cancel=true";

export const PAYMENT_INFO_SUCCESS_PATH = "https://app.bemakers.com/payment-info?success=true";
export const PAYMENT_INFO_CANCEL_PATH = "https://app.bemakers.com/payment-info?cancel=true";
export const STG_PAYMENT_INFO_SUCCESS_PATH = "https://app.staging-bemakers.com/payment-info?success=true";
export const STG_PAYMENT_INFO_CANCEL_PATH = "https://app.staging-bemakers.com/payment-info?cancel=true";
// Stripe - end

export const RESET_PASSWORD_PATH = "/reset-password";
export const RESET_PASSWORD_SENT_PATH = "/reset-password/sent";
export const RESET_PASSWORD_CONFIRM_PATH = "/reset-password/confirm/:token";
export const RESET_PASSWORD_SUCCESS_PATH = "/reset-password/success";

export const PICKING_LIST_PATH = "/picking-list/:token";

export const WAREHOUSE_STOCK_MOVEMENTS_PATH = "/stock-movement/warehouses/:token";
export const WAREHOUSE_STOCK_MOVEMENT_PREVIEW_PATH = "/stock-movement/warehouses/:stockMovementId/:token";
export const WAREHOUSE_STOCK_MOVEMENT_CONFIRM_PATH = "/stock-movement/confirm/:token";

export const READY_FOR_PICKUP_PATH = "/ready-for-pickup/:token";

export const ORDERS_PATH = "/orders";
export const ORDER_TABS_PATH = "/orders/tabs/:orderTab";
export const ORDER_NEW_PATH = "/orders/new";
export const ORDER_PREVIEW_PATH = "/orders/:orderId";
export const ORDER_EDIT_PATH = "/orders/:orderId/edit";
export const ORDER_TRACEZILLA_DOCUMENTS_PATH = "/tracezilla/:tracezillaOrderId/docs";

export const PRODUCTS_PATH = "/products";

export const BEVERAGE_PREVIEW_PATH = "/products/beverages/:productId";
export const BEVERAGE_NEW_PATH = "/products/beverages/new";
export const BEVERAGE_EDIT_PATH = "/products/beverages/:productId/edit";

export const BUNDLE_PREVIEW_PATH = "/products/bundles/:productId";
export const BUNDLE_NEW_PATH = "/products/bundles/new";
export const BUNDLE_EDIT_PATH = "/products/bundles/:productId/edit";

export const EXTRA_NEW_PATH = "/products/extras/new";
export const EXTRA_PREVIEW_PATH = "/products/extras/:productId";
export const EXTRA_EDIT_PATH = "/products/extras/:productId/edit";

export const PRODUCT_PRICES_BULK_PREVIEW_PATH = "/product-prices";
export const PRODUCT_PRICES_BULK_EDIT_PATH = "/product-prices/edit";

export const CUSTOMERS_PATH = "/customers";
export const DISABLED_CUSTOMERS_PATH = "/disabled-customers";
export const CUSTOMER_NEW_PATH = "/customers/new";
export const CUSTOMER_PREVIEW_PATH = "/customers/:customerId";
export const CUSTOMER_EDIT_PATH = "/customers/:customerId/edit";
export const CUSTOMER_PRICELIST_PATH = "/customers/:customerId/pricelist";
export const CUSTOMER_BUSINESS_MEMBER_PREVIEW_PATH = "/customers/:customerId/user/:businessMemberId";

export const ACTIVITIES_PATH = "/activities";
export const ACTIVITY_TABS_PATH = "/activities/tabs/:activityTab";
export const ACTIVITIES_PREVIEW_PATH = "/activities/:activityId";
export const ACTIVITIES_EDIT_PATH = "/activities/:activityId/edit";

export const CAMPAIGNS_LIST_PATH = "/campaigns";
export const CAMPAIGNS_TABS_PATH = "/campaigns/tabs/:campaignTab";
export const CAMPAIGN_NEW_PATH = "/campaigns/new";
export const CAMPAIGN_PREVIEW_PATH = "/campaigns/:campaignId";
export const CAMPAIGN_EDIT_PATH = "/campaigns/:campaignId/edit";

export const REPORTS_PATH = "/reports";
export const TAX_WATEHOUSE_REPORT_PATH = "/reports/tax-warehouse-report";
export const RECYCLING_REPORT_PATH = "/reports/recycling-report";

// commerce - start
export const WEBSHOP_PRODUCTS_ROOT_PATH = "/store/:storeId/store-product";
export const WEBSHOP_PRODUCTS_PATH = "/store/:storeId/store-product/:country";
export const WEBSHOP_PRODUCT_NEW_PATH = "/store/:storeId/store-product/:country/new";
export const WEBSHOP_PRODUCT_PREVIEW_PATH = "/store/:storeId/store-product/:country/:shopProductId";
export const WEBSHOP_PRODUCT_EDIT_PATH = "/store/:storeId/store-product/:country/:shopProductId/edit";
export const WEBSHOP_PRODUCT_META_EDIT_PATH = "/store/:storeId/store-product/:country/:shopProductId/editMeta";

export const COLLECTION_ROOT_PATH = "/store/:storeId/collection";
export const COLLECTIONS_PATH = "/store/:storeId/collection/:country";
export const COLLECTION_NEW_PATH = "/store/:storeId/collection/:country/new";
export const COLLECTION_PREVIEW_PATH = "/store/:storeId/collection/:country/:collectionId";
export const COLLECTION_EDIT_PATH = "/store/:storeId/collection/:country/:collectionId/edit";
export const COLLECTION_EDIT_META_PATH = "/store/:storeId/collection/:country/:collectionId/editMeta";

export const DISCOUNT_ROOT_PATH = "/store/:storeId/discount";
export const DISCOUNTS_PATH = "/store/:storeId/discount/:country";
export const DISCOUNT_NEW_PATH = "/store/:storeId/discount/:country/new";
export const DISCOUNT_EDIT_PATH = "/store/:storeId/discount/:country/:discountId/edit";

export const BANNER_ROOT_PATH = "/store/:storeId/banner";
export const BANNERS_PATH = "/store/:storeId/banner/:country";
export const PROMO_BANNER_NEW_PATH = "/store/:storeId/banner/:country/promo-banner/new";
export const PROMO_BANNER_EDIT_PATH = "/store/:storeId/banner/:country/promo-banner/:bannerId/edit";
export const ANNOUNCEMENT_BAR_NEW_PATH = "/store/:storeId/banner/:country/announcement-bar/new";
export const ANNOUNCEMENT_BAR_EDIT_PATH = "/store/:storeId/banner/:country/announcement-bar/:announcementId/edit";

export const SHIPPING_RATES_ROOT_PATH = "/store/:storeId/shipping-rates";
export const SHIPPING_RATES_PREVIEW_PATH = "/store/:storeId/shipping-rates/:country";
export const SHIPPING_RATES_EDIT_PATH = "/store/:storeId/shipping-rates/:country/edit";

export const CONFIGURATION_ROOT_PATH = "/store/:storeId/configuration";
export const CONFIGURATION_EDIT_PATH = "/store/:storeId/configuration/edit";
export const CONFIGURATION_COUNTRY_PREVIEW_PATH = "/store/:storeId/configuration/:country";
export const CONFIGURATION_COUNTRY_EDIT_PATH = "/store/:storeId/configuration/:country/edit";

export const COMMERCE_RATES_ROOT_PATH = "/store/:storeId/commerce";
// commerce - end

// fulfillment - start
export const STOCK_MOVEMENTS_ROOT_PATH = "/stock-movements";
export const STOCK_MOVEMENTS_NEW_PATH = "/stock-movements/new";
export const STOCK_MOVEMENTS_PREVIEW_PATH = "/stock-movements/:stockMovementId";
export const STOCK_MOVEMENTS_EDIT_PATH = "/stock-movements/:stockMovementId/edit";

export const WAREHOUSES_ROOT_PATH = "/warehouses";

export const FULFILLMENT_RULES_ROOT_PATH = "/fulfillment-rules";
// fulfillment - end

// finances - start
export const BALANCE_PATH = "/finances/balance";
export const ORDER_SETTLEMENTS_PATH = "/finances/order-settlements";
export const FINANCIAL_STATEMENTS_PATH = "/finances/financial-statements";
// finances - end

// listings - start
export const LISTINGS_PATH = "/listings";
// listings - end

// settings - start
export const SERVICE_PAGE_PATH = "/service-page";

export const COMPANY_INFO_ROOT_PATH = "/company";
export const COMPANY_INFO_EDIT_PATH = "/company/edit";

export const USERS_PATH = "/users";
export const USERS_INVITATIONS_PATH = "/users/invitations";
export const USER_PREVIEW_PATH = "/users/:membershipId";
export const USER_EDIT_PATH = "/users/:membershipId/edit";
export const USERS_INVITATION_PREVIEW_PATH = "/users/invitation/:invitationId";

export const NOTIFICATIONS_PATH = "/notifications";
export const NOTIFICATIONS_EDIT_PATH = "/notifications/edit";

export const PAYMENT_INFO_ROOT_PATH = "/payment-info";
export const PAYMENT_INFO_EDIT_PATH = "/payment-info/edit";

export const LOCATIONS_ROOT_PATH = "/locations";
export const LOCATIONS_NEW_PATH = "/locations/new";
export const LOCATIONS_PREVIEW_PATH = "/locations/:locationId";
export const LOCATIONS_EDIT_PATH = "/locations/:locationId/edit";

export const BRANDS_PATH = "/brands";
export const BRAND_NEW_PATH = "/brands/new";
export const BRAND_EDIT_PATH = "/brands/:brandId/edit";
// settings - end

// business tools - start
export const BUSINESS_TOOLS_PATH = "/business-tools";
export const SHIPPING_PRICE_CALCULATOR_PATH = "/business-tools/shipping-price-calculator";
export const VAT_CALCULATOR_PATH = "/business-tools/vat-calculator";
export const PRICE_CALCULATOR_PREVIEW_PATH = "/business-tools/price-calculator";
export const PRICE_CALCULATOR_NEW_PATH = "/business-tools/price-calculator/new";
export const PRICE_CALCULATOR_EDIT_PATH = "/business-tools/price-calculator/:calculatorId/edit";
// business tools - end

// Union of all path constants that contain :storeId and :country.
// Used by useMarketPath to restrict its pattern argument at compile time.
export type MarketPath =
  | typeof WEBSHOP_PRODUCTS_PATH
  | typeof WEBSHOP_PRODUCT_NEW_PATH
  | typeof WEBSHOP_PRODUCT_PREVIEW_PATH
  | typeof WEBSHOP_PRODUCT_EDIT_PATH
  | typeof WEBSHOP_PRODUCT_META_EDIT_PATH
  | typeof COLLECTIONS_PATH
  | typeof COLLECTION_NEW_PATH
  | typeof COLLECTION_PREVIEW_PATH
  | typeof COLLECTION_EDIT_PATH
  | typeof COLLECTION_EDIT_META_PATH
  | typeof DISCOUNTS_PATH
  | typeof DISCOUNT_NEW_PATH
  | typeof DISCOUNT_EDIT_PATH
  | typeof BANNERS_PATH
  | typeof PROMO_BANNER_NEW_PATH
  | typeof PROMO_BANNER_EDIT_PATH
  | typeof ANNOUNCEMENT_BAR_NEW_PATH
  | typeof ANNOUNCEMENT_BAR_EDIT_PATH
  | typeof SHIPPING_RATES_PREVIEW_PATH
  | typeof SHIPPING_RATES_EDIT_PATH
  | typeof CONFIGURATION_ROOT_PATH
  | typeof CONFIGURATION_COUNTRY_PREVIEW_PATH
  | typeof CONFIGURATION_COUNTRY_EDIT_PATH;

// other
export const NOT_FOUND_PATH = "/not-found";
export const IMPERSONATE_PATH = "/impersonate";
export const ZENDESK_SSO_PATH = "/zendesk-sso";
